/* Storage seam — THE Phase 3 swap point
 *
 * Moved verbatim from currencykeep_2026-08-03.html, lines 368-391.
 * The body below is byte-identical to the original; only the import
 * block above and the export block below were added. (Phase 1, Step 2.)
 */

import { installRemoteStorage } from './remote.js'

// Attaches the Supabase-backed storage as window.storage, with idb.js
// behind it for photos. MUST stay above the HAS line below — see
// scripts/extract.mjs for why. (Phase 1 Step 3; Phase 3 Step 4.)
installRemoteStorage()

const HAS=typeof window!=="undefined"&&window.storage;
const KEY="notevault:collection";
/* All writes go through one queue: the storage backend rejects overlapping
   writes, so we run them strictly one-at-a-time and retry transient failures. */
let _wchain=Promise.resolve();
function storageSet(key,value,shared){
  const run=async()=>{
    let last;
    for(let i=0;i<3;i++){
      try{return await window.storage.set(key,value,!!shared);}
      catch(e){last=e;if(i<2)await new Promise(r=>setTimeout(r,220*(i+1)));}
    }
    throw last;
  };
  const p=_wchain.then(run,run);
  _wchain=p.then(()=>{},()=>{});
  return p;
}
function storageDel(key,shared){
  const run=async()=>{try{return await window.storage.delete(key,!!shared);}catch(e){}};
  const p=_wchain.then(run,run);
  _wchain=p.then(()=>{},()=>{});
  return p;
}

export {
  HAS,
  KEY,
  storageDel,
  storageSet,
}
